import { MutationTree } from 'vuex';
import { ProfileState } from './types';

export const mutations: MutationTree<ProfileState> = {
  profileLoaded(state, payload: ProfileState) {
    state.user = payload.user;
    state.authorize = payload.authorize;
  }
};
